import React from 'react';
import {useTranslation} from "react-i18next";
import {observer} from "mobx-react-lite";
import Header from "../components/Header";

import image from '../img/logo404.svg'
import GenerateURL from "../utils/generateURL";
import {INDEX_ROUTE} from "../utils/consts";
import {NavLink} from "react-router-dom";
import cookie from "js-cookie";

const ErrorPage = props => {
  const { t } = useTranslation();
  const status = props.status || cookie.get('ErrorStatus') || 'Unknown error';
  const currentError = {
    400: {
      title: "Bad Request"
    },
    403: {
      title: "Forbidden"
    },
    404: {
      title: "Page not found"
    },
    500: {
      title: "Internal Server Error"
    },
    'Unknown error': {
      title: ""
    }
  };

  return currentError[status] && (
      <div className="fhf background">
        {window.location.pathname.indexOf(`/adm/`) === -1 &&<section>
          <Header />
        </section>}
        <section className="details_content content">
          <div className="virtual">
            <div className="row">
              <div className="virtual_left">
                <div className="virtual_left_img">
                  <img src={image} alt="" />
                </div>
              </div>
              <div className="virtual_right">
                <div className="virtual_right_box">
                  <div className="title_block">
                    {status && <h1>{status} {t(currentError[status].title)}</h1>}
                    <p>
                      {`${t('Sorry, it appears the page you were looking for does not no longer available.')} ${t('Please try your luck again!')}` }
                    </p>
                  </div>
                  <div className="virtual_right_box_links">
                    {window.location.pathname.indexOf(`/adm/`) === -1
                        ? <NavLink to={GenerateURL(INDEX_ROUTE)}>{t('BACK TO HOME')}</NavLink>
                        : <a href={`${INDEX_ROUTE}adm/`}>{t('BACK TO HOME')}</a>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
  );
};

export default observer(ErrorPage);